export const PATHS = {
  //Dashboard
  LANDING_PAGE: "/",

  // Authentication
  API_SCRAPE: "/apiLoad",
  LOGIN: "/login",
  LOGIN_CALLBACK: "/loginCallback",
  LOGGED_OUT: "/loggedOut",
  LOG_OUT: "/logout",

  // Onboarding
  ONBOARDING_WELCOME: "/welcome",
  ONBOARDING_WELCOME_UNPAID_INVITE: "/welcome/invite-up",
  ONBOARDING_WELCOME_PAID_INVITE: "/welcome/invite-p",
  ONBOARDING_GENOMIC_LIFE_COMPLETE_PRODUCT: "/onboarding/unpaid-product",

  ONBOARDING_REGISTRATION_INSTRUCTIONS: "/onboarding/registrationInstructions",
  ONBOARDING_GETTING_STARTED: "/onboarding/gettingStarted",
  ONBOARDING_TERMS: "/onboarding/terms",
  ONBOARDING_PROFILE: "/onboarding/profile",
  ONBOARDING_UNPAID_INVITE_PROFILE: "/onboarding/unpaid-invite/profile",
  ONBOARDING_UNPAID_INVITE_PAYMENT: "/onboarding/unpaid-invite/payment",

  // Account Management
  ACCOUNT: "/account",
  ACCOUNT_MANAGEMENT: "/account/management",
  ACCOUNT_MANAGEMENT_MEMBER_INFORMATION:
    "/account/management/memberInformation",
  ACCOUNT_MANAGEMENT_MFA: "/account/management/mfa",
  ACCOUNT_MANAGEMENT_PAYMENT_INFORMATION:
    "/account/management/paymentInformation",
  ACCOUNT_MANAGEMENT_PRIVACY_AND_SECURITY:
    "/account/management/privacyAndSecurity",
  ACCOUNT_MANAGEMENT_UPDATE_AGREEMENTS: "/account/management/updateTerms",
  ACCOUNT_MANAGEMENT_PRIVACY_POLICY: "/account/management/privacyPolicy",
  ACCOUNT_MANAGEMENT_TERMS_AND_CONDITIONS:
    "/account/management/termsAndConditions",
  ACCOUNT_MANAGEMENT_AGREEMENTS: "/account/management/termsOfService",
  ACCOUNT_MANAGEMENT_HIPAA: "/account/management/hipaaAuthorization",
  ACCOUNT_MANAGEMENT_RESET_PASSWORD: "/account/management/resetPassword",
  ACCOUNT_MANAGEMENT_EXPLANATION_OF_BENEFITS:
    "/account/management/explanationOfBenefits",
  ACCOUNT_MANAGEMENT_MEMBERSHIP_PAYMENT:
    "/account/management/membershipPayment",
  ACCOUNT_MANAGEMENT_PAYMENT_RECEIPT: "/account/management/paymentReceipt",
  ACCOUNT_MANAGEMENT_GIFT_MEMBERSHIP: "/account/management/giftMembership",
  ACCOUNT_MANAGEMENT_GIFT_RECIPIENTS: "/account/management/giftRecipients",
  ACCOUNT_MANAGEMENT_GIFT_PAYMENT: "/account/management/giftPayment",
  ACCOUNT_MANAGEMENT_MEMBERSHIP_INVITE: "/account/management/membershipInvite",
  ACCOUNT_MANAGEMENT_CANCEL_MEMBERSHIP: "/account/management/cancelMembership",

  // Survey Pages
  CANCER_SURVEY: "/survey/cancerDiagnosisSurvey",
  GETTING_STARTED_SURVEY: "/survey/gettingStarted",
  KIT_REQUEST_SURVEY: "/survey/kitRequest",
  ORDER_KIT_INFORMED_CONSENT_SURVEY: "/survey/orderKitInformedConsent",

  // Kit Ordering
  ORDER_KIT: "/orderKit",
  ORDER_KIT_CONFIRMATION: "/orderKit/confirmation",
  ORDER_KIT_SELECTION: "/orderKit/info",

  // Report and Results
  RESULTS_SLIDES: "/testResults/resultsSlides",
  RESULTS_MORE_INFO_SLIDE: "/testResults/resultsMoreInfoSlide",
  TEST_RESULTS_PAGE: "/testResults",
  VIEW_TEST_PAGE: "/testResults/test",

  // CMS Controlled Pages
  HELP_CENTER_ROOT: "/content/help-center",
  HELP_CENTER_CONTACT_US: "/content/help-center/articles/contact-us/",
  HELP_CENTER: "/content/help-center*",

  // Redirects to CMS to support legacy links in the wild
  CANCER_AND_GENOMICS: "/cancerAndGenomics",
  CANCER_GUARDIAN_RESOURCE: "/cancerGuardianResource",
  PROGRAM_INFORMATION: "/programInformation",
  RESOURCE_CENTER: "/resource-center",
  WHY_GENOMICS: "/whyGenomics",
  CANCER_RESOURCE_LIBRARY: "/content/cancer-resource-library*",

  // Utility pages
  MAINTENANCE: "/maintenance"
};
